function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M15.998 0C7.165 0 0 7.163 0 16c0 7.07 4.584 13.066 10.942 15.182.8.147 1.092-.347 1.092-.771 0-.38-.014-1.386-.021-2.721-4.45.966-5.39-2.145-5.39-2.145-.728-1.849-1.777-2.34-1.777-2.34-1.452-.993.11-.973.11-.973 1.606.113 2.451 1.649 2.451 1.649 1.427 2.445 3.745 1.738 4.657 1.329.145-1.033.559-1.739 1.015-2.138-3.552-.404-7.288-1.777-7.288-7.908 0-1.747.624-3.176 1.647-4.294-.165-.404-.714-2.032.158-4.234 0 0 1.342-.43 4.399 1.64A15.325 15.325 0 0 1 16 7.737a15.33 15.33 0 0 1 4.006.54c3.055-2.071 4.395-1.641 4.395-1.641.874 2.202.325 3.83.16 4.234 1.026 1.118 1.645 2.547 1.645 4.294 0 6.146-3.741 7.499-7.305 7.895.574.494 1.085 1.47 1.085 2.963 0 2.139-.02 3.864-.02 4.389 0 .428.29.926 1.1.77C27.42 29.06 32 23.068 32 16c0-8.838-7.164-16-16.002-16z",
  clipRule: "evenodd"
});

var SvgGithub = function SvgGithub(props) {
  return React.createElement("svg", _extends({
    fill: "#1B1F23",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "c1866c14565459e5e07ed9dcdf3840a2.svg";
export { SvgGithub as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/github.svg
// module id = null
// module chunks = 